import { agentRadarResponseSchema, blastRadiusResponseSchema, riskFlowResponseSchema, } from '../contracts/ai-risk-map';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * KIR-5075: Risk Flow data (alerts or inventory dataset) for the AI Risk Map.
 */
export async function getOrganizationRiskFlow(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/dashboard/risk-map/flow`, { params });
    return parseSchema(riskFlowResponseSchema, response);
}
/**
 * KIR-5075: Blast Radius graph for the AI Risk Map.
 */
export async function getOrganizationBlastRadius(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/dashboard/risk-map/blast-radius`, { params });
    return parseSchema(blastRadiusResponseSchema, response);
}
/**
 * KIR-5075: Agent Radar snapshot (live agent activity) for the AI Risk Map.
 */
export async function getOrganizationAgentRadar(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/dashboard/risk-map/radar`, { params });
    return parseSchema(agentRadarResponseSchema, response);
}
//# sourceMappingURL=ai-risk-map.js.map